module.exports = __webpack_public_path__ + "img/about1.16435d62.webp";